import React from "react";

const Buttons = ({
  onClick,
  color = "red",
  textColor = "white",
  buttonText,
  children,
  className = "",
}) => {
  // Background color mapping
  const backgroundColors = {
    red: "#67142D",
    white: "#FFFFFF",
  };

  // Text color mapping
  const textColors = {
    black: "#000000",
    white: "#FFFFFF",
  };

  const bgColor = backgroundColors[color] || color; // allows custom color string too
  const txtColor = textColors[textColor] || textColor;

  return (
    <button
      onClick={onClick}
      className={`rounded-md px-4 py-2 font-inter font-medium text-[17px] max-lg:text-[10px] ${className}`}
      style={{
        backgroundColor: bgColor,
        color: txtColor,
      }}
    >
      {buttonText}
      {children && <span className="ml-2">{children}</span>}
    </button>
  );
};

export default Buttons;
